import { InjectionToken, Signal } from '@angular/core'

/**
 * Which variant of the shared navigation components to use, e.g. breadcrumbs, the 404 page,
 * auth pages and menus. It does not change an app's own header or layout: ftr-admin keeps its
 * legacy-style header but uses the `redesign` variants of these shared components.
 */
export type NavigationShell = 'redesign' | 'legacy'

export const NAVIGATION_SHELL = new InjectionToken<Signal<NavigationShell>>('NAVIGATION_SHELL')
